import React from 'react';
import { FaCheck, FaPen, FaTimes, FaTrash } from 'react-icons/fa';
import { ChakraV3 } from '../..';

interface EditableControlsProps extends ChakraV3.StackProps {
  onRemove?: () => void;
}

export const EditableControls = (props: EditableControlsProps) => {
  const { onRemove, ...rest } = props;

  return (
    <ChakraV3.HStack {...rest}>
      <ChakraV3.Editable.Control>
        <ChakraV3.Editable.EditTrigger asChild>
          <ChakraV3.IconButton variant='ghost' size='2xs' aria-label='Edit'>
            <FaPen />
          </ChakraV3.IconButton>
        </ChakraV3.Editable.EditTrigger>
        <ChakraV3.Editable.SubmitTrigger asChild>
          <ChakraV3.IconButton variant='ghost' size='2xs' aria-label='Submit'>
            <FaCheck />
          </ChakraV3.IconButton>
        </ChakraV3.Editable.SubmitTrigger>
        <ChakraV3.Editable.CancelTrigger asChild>
          <ChakraV3.IconButton variant='ghost' size='2xs' aria-label='Cancel'>
            <FaTimes />
          </ChakraV3.IconButton>
        </ChakraV3.Editable.CancelTrigger>
        {onRemove && (
          <ChakraV3.IconButton variant='ghost' size='2xs' aria-label='Remove' onClick={onRemove}>
            <FaTrash />
          </ChakraV3.IconButton>
        )}
      </ChakraV3.Editable.Control>
    </ChakraV3.HStack>
  );
};
